const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8005'

export const getCustomers = async ({ delivery_date, meisei_code } = {}) => {
  const url = `${API_BASE}/customers?delivery_date=${encodeURIComponent(delivery_date)}&meisei_code=${encodeURIComponent(meisei_code)}`
  const res = await fetch(url)
  if (!res.ok) throw new Error(`Customers fetch failed: ${res.status}`)
  const data = await res.json()
  const list = Array.isArray(data) ? data : data.data || data.customers || []
  return list.map((c, i) => ({
    CUSTOMER_CODE: c.CUSTOMER_CODE ?? c.customer_code ?? c.code ?? `CUST-${i}`,
    BRANCH_CODE: c.BRANCH_CODE ?? c.branch ?? '',
    MEISEI_HINMEI_CD: c.MEISEI_HINMEI_CD ?? c.meisei_code ?? meisei_code ?? '',
    GRADE: c.GRADE ?? '',
    SIZE: c.SIZE ?? '',
    PRODUCTION: c.PRODUCTION ?? '',
    ORDER_QUANTITY: Number(c.ORDER_QUANTITY ?? c.order_qty ?? c.qty ?? 0),
    PRIORITY: c.PRIORITY ?? 1,
    SATISFACTION_PERCENT: c.SATISFACTION_PERCENT ?? 100,
    AGENTLIST: c.AGENTLIST || []
  }))
}

export const fetchSellers = async () => {
  const url = `${API_BASE}/sellers`
  console.log('Fetching sellers from:', url)
  const res = await fetch(url)
  console.log('Sellers response status:', res.status)
  if (!res.ok) throw new Error(`Sellers fetch failed: ${res.status}`)
  const data = await res.json()
  console.log('Sellers raw data:', data)
  const sellers = data.data || []
  console.log('Parsed sellers:', sellers)
  return sellers.map((s) => ({ id: s.seller_cd, name: s.seller_name }))
}

export const fetchProductsByCodes = async ({ delivery_date, list_hic }) => {
  const params = new URLSearchParams({
    delivery_date: delivery_date,
    list_hic: list_hic
  })
  const url = `${API_BASE}/products_by_codes?${params}`
  const res = await fetch(url)
  if (!res.ok) throw new Error(`Products by codes fetch failed: ${res.status}`)
  const data = await res.json()
  return data.data || []
}

export const fetchProductsBySellerCode = async ({
  seller_cd,
  delivery_date,
  days_query,
  product_codes,
  inventory_start_date
}) => {
  const params = new URLSearchParams({
    seller_cd,
    delivery_date,
    days_query
  })
  if (inventory_start_date) params.set('inventory_start_date', inventory_start_date)

  if (
    product_codes &&
    Array.isArray(product_codes) &&
    product_codes.length > 0
  ) {
    params.append('selected_product', product_codes.join(','))
  }

  const url = `${API_BASE}/products_by_seller_code?${params}`
  const res = await fetch(url)
  if (!res.ok) throw new Error(`Products fetch failed: ${res.status}`)
  const data = await res.json()
  return data.data || []
}

export const allocateWithProducts = async (payload = {}) => {
  const {
    seller_cd,
    delivery_date,
    products,
    meisei_code,
    list_hic,
    days_query,
    inventory_start_date
  } = payload

  const body = {
    seller_cd,
    delivery_date,
    days_query,
    inventory_start_date
  }

  // New API: products can be an array or a JSON string
  if (products !== undefined) {
    if (typeof products === 'string') {
      try {
        body.products = JSON.parse(products)
      } catch {
        // If it's already a plain string (or invalid), send as-is
        body.products = products
      }
    } else {
      body.products = products
    }
  }

  // Legacy compatibility: some callers used list_hic
  if (body.products === undefined && list_hic !== undefined) {
    body.list_hic = list_hic
  }

  if (meisei_code !== undefined) {
    body.meisei_code = meisei_code
  }

  const url = `${API_BASE}/allocate-with-products`
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })

  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(`Allocate failed: ${res.status}${text ? ` - ${text}` : ''}`)
  }
  return res.json()
}

export const fetchHinmeiByName = async (name, limit = 20) => {
  const params = new URLSearchParams({
    name: name,
    limit: limit.toString()
  })
  const url = `${API_BASE}/hinmei?${params}`
  const res = await fetch(url)
  if (!res.ok) throw new Error(`Hinmei search failed: ${res.status}`)
  const data = await res.json()
  return data.data || []
}

export const fetchShippersByHinmei = async (listHic) => {
  const params = new URLSearchParams()
  listHic.forEach((hic) => params.append('list_hic', hic))
  const url = `${API_BASE}/shippers?${params}`
  const res = await fetch(url)
  if (!res.ok) throw new Error(`Shippers fetch failed: ${res.status}`)
  const data = await res.json()
  return data.data || []
}
